// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");
require("component-leaflet-map");

var mapElement = document.querySelector("leaflet-map");
var map = mapElement.map;
var lookup = mapElement.lookup;
map.fitBounds([lookup.westbound.getLatLng(), lookup.eastbound.getLatLng()]);
lookup.crash.openPopup();